<!-- @Version: 1.0.4 --> 
@if (done$$() == true) {
   <div class = "row" [formGroup]="fgAutocomplete">
      <mat-form-field data-width="100%">
         <mat-label [innerHTML]="label == undefined ? (translatePath +  TRANSLATE_SUFFIX.LABEL | translateDesign) : label"></mat-label>
         <input data-testid = "input" matInput [matAutocomplete]="auto1" [formControlName]="FC_AUTOCOMPLETE.VALUE" (blur)="onBlur()" (keydown.enter)="keyenter($event)">
         <button [disabled]="isFinished" mat-icon-button type="button" matSuffix aria-label="Öffnet Auswahlliste"><mat-icon>keyboard_arrow_down</mat-icon></button>
         <mat-autocomplete data-testid="topic" placeholder #auto1="matAutocomplete" [displayWith]="displayFn.bind(this)">
            @for (option of filteredList$$(); track option) {
               <mat-option [value]="option.key" [attr.data-testid]="'option_' + option.key" (mousedown)="mousedown($event)">
                  {{option.desc}}
               </mat-option>
            }
         </mat-autocomplete>
         @if (fgAutocomplete.get(FC_AUTOCOMPLETE.VALUE)?.hasError(FORMERROR.notAllowed)) {
           <mat-error data-testid="error-notAllowed-topic">{{translatePath + TRANSLATE_SUFFIX.ERROR_NOT_ALLOWED | translateDesign}} {{value}}</mat-error>
         }
         @if (fgAutocomplete.get(FC_AUTOCOMPLETE.VALUE)?.hasError(FORMERROR.required)) {
           <mat-error data-testid="error-required-topic">{{translatePath +  TRANSLATE_SUFFIX.ERROR_REQUIRED  | translateDesign}}</mat-error>
         }
       </mat-form-field>
   </div>
}